export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/ob-step-14.png?a4a197bd095f9656bb5d3a3e34e9d2fb";